import { useState } from 'react'
import { Link, NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { appConfig } from '../config/app'
import { errorMessage } from '../lib/errors'

export function AppShell() {
  const { user, signOut } = useAuth()
  const [signOutError, setSignOutError] = useState('')

  async function handleSignOut() {
    setSignOutError('')
    try {
      await signOut()
    } catch (error) {
      setSignOutError(errorMessage(error))
    }
  }

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-lg px-3 py-2 text-sm font-bold ${isActive ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-slate-950 text-white shadow-xl">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6">
          <Link className="flex items-center gap-3" to="/">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-blue-600 text-lg font-black" aria-hidden="true">T</span>
            <span><strong className="block leading-tight">{appConfig.name}</strong><small className="text-slate-400">Escritório · v{appConfig.version}</small></span>
          </Link>
          <nav className="order-3 flex w-full items-center gap-1 sm:order-2 sm:w-auto" aria-label="Principal">
            <NavLink className={navClass} end to="/">Painel</NavLink>
            <NavLink className={navClass} to="/cadastros">Cadastros</NavLink>
          </nav>
          <div className="order-2 flex items-center gap-3 sm:order-3">
            <a
              className="hidden rounded-lg bg-emerald-600 px-3 py-2 text-sm font-bold text-white hover:bg-emerald-500 md:inline"
              href="https://web.whatsapp.com/"
              rel="noreferrer"
              target="_blank"
            >Abrir WhatsApp Web</a>
            <span className="hidden max-w-48 truncate text-xs text-slate-400 lg:inline">{user?.email}</span>
            <button className="rounded-lg px-3 py-2 text-sm font-bold text-slate-300 hover:bg-slate-800 hover:text-white" onClick={() => void handleSignOut()} type="button">Sair</button>
          </div>
        </div>
      </header>
      <a
        className="mx-4 mt-4 block rounded-lg bg-emerald-600 px-3 py-2 text-center text-sm font-bold text-white md:hidden"
        href="https://web.whatsapp.com/"
        rel="noreferrer"
        target="_blank"
      >Abrir WhatsApp Web</a>
      {signOutError ? <p className="notice-error mx-auto mt-4 max-w-7xl" role="alert">{signOutError}</p> : null}
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8"><Outlet /></main>
    </div>
  )
}
